<template>
    <div>
        <v-form ref="form" v-model="valid">
            <v-card>
                <v-card-title>
                    <span>Non Typical Entry Form</span>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-subtitle>Instructions for filling form</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <div class="px-2">
                        <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                            <div class="w-full md:w-1/2 px-2">
                                <v-text-field :rules="[rules.requiredRule]" v-model="form.full_name" label="Full Name" prepend-icon="person" hint="LastName, FirstName"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <v-text-field :rules="[rules.requiredRule, rules.uinLength]" v-model="form.uin" label="UIN"  hint="9 digit UIN"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <v-text-field type="phone" :rules="[rules.requiredRule, rules.phoneLength]" v-model="form.phone_number" label="Contact Number" prepend-icon="phone" hint="10 digit phone number"></v-text-field>
                            </div>
                            <div class="w-full md:w-1/2 px-2">
                                <v-text-field type="office"  v-model="form.office" label="Office Address" prepend-icon="work" hint="Office Address of Employees"></v-text-field>
                            </div>
                        </div>
                    </div>
                    <v-divider></v-divider>

                    <v-card-subtitle>Vehicle Information</v-card-subtitle>
                    <div class="px-2">
                        <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                            <div  class="w-full md:w-1/2 px-2 mb-5">
                                <v-card>
                                    <v-card-title>Vehicle</v-card-title>
                                    <v-card-text>
                                        <div class="px-2">
                                            <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                                                <div class="w-full md:w-full px-2">
                                                    <v-text-field v-model="form.vehicle.vehicle_licence_plate" :rules="[rules.requiredRule]" prepend-icon="directions_car" label="License Plate"></v-text-field>
                                                </div>
                                                <div class="w-full md:w-1/2 px-2">
                                                    <v-select v-model="form.vehicle.vehicle_state" :items="dropdowns.vehiclestate" :rules="[rules.requiredRule]" item-text="desc" item-value="state" prepend-icon="place" label="State"></v-select>
                                                </div>
                                                <div class="w-full md:w-1/2 px-2">
                                                    <v-text-field v-model="form.vehicle.vehicle_year" prepend-icon="calendar_today" :rules="[rules.requiredRule]" label="Year"></v-text-field>
                                                </div>
                                                <div class="w-full md:w-1/2 px-2">
                                                    <v-select v-model="form.vehicle.vehicle_make" :items="dropdowns.vehiclemake" :rules="[rules.requiredRule]" item-text="vc_make_desc" item-value="vc_make_cd" prepend-icon="branding_watermark" label="Make"></v-select>
                                                </div>
                                                <div class="w-full md:w-1/2 px-2">
                                                    <v-select v-model="form.vehicle.vehicle_color" :items="dropdowns.vehiclecolor" :rules="[rules.requiredRule]" item-text="vc_color_desc" item-value="vc_color_code" prepend-icon="palette" label="Color"></v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </div>
                        </div>
                    </div>
                    <v-divider></v-divider>

                    <v-card-subtitle>Permit Information</v-card-subtitle>
                    <div class="px-2">
                        <div class="flex flex-wrap justify-start content-center items-center -mx-4">
                            <div class="w-full md:w-1/2 px-2 mb-5">
                                <v-select v-model="form.permit_type" :loading="isLoadingPermitTypes" prepend-icon="list"
                                          :items="permitTypes" item-text="description" item-value="permit_type_code"
                                          label="Permit Type" :rules="[rules.requiredRule]"
                                ></v-select>
                            </div>
                            <div class="w-full md:w-1/2 px-2 mb-5">
                                <v-text-field v-model="form.permit_number" prepend-icon="format_list_numbered" hint="Permit Number"
                                              append-outer-icon="autorenew" label="Permit Number" :loading="isLoadingPermitNumber"
                                              @click:append-outer="onClickGeneratePermitNumber" :rules="[rules.requiredRule]"
                                ></v-text-field>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="resetForm" color="error"><v-icon>clear</v-icon>cancel</v-btn>
                    <v-btn @click="onSubmitForm" :loading="isLoadingFormSubmit" color="success"><v-icon>send</v-icon>Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
        <v-snackbar v-model="snack" :bottom="true" :right="true" :timeout="3000" :color="snackColor">
            {{ snackText }}
            <v-btn text dark  class="" @click="snack = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                appURL: process.env.MIX_APP_URL,
                snack: false,
                valid: false,
                snackColor: '',
                snackText: '',
                rules: {
                    requiredRule: value => !! value || 'Required',
                    phoneLength: v => (v || "").length === 10 || "Exact 10 characters",
                    uinLength: v => (v || "").length === 9 || "Exact 9 characters",
                },
                permitTypeUser: [
                    { text: 'Employee', value: 'E'},
                    { text: 'Student', value: 'S'},
                    { text: 'Resident', value: 'R'},
                ],
                permitTypes: [],
                isLoadingPermitTypes: false,
                isLoadingFormSubmit: false,
                isLoadingPermitNumber: false,
                form: {
                    uin: '',
                    full_name: '',
                    phone_number: '',
                    office: '',
                    vehicle: {
                        vehicle_licence_plate: '',
                        vehicle_state: '',
                        vehicle_year: '',
                        vehicle_make: '',
                        vehicle_color: '',
                    },
                    permit_type: '',
                    permit_number: '',
                }
            }
        },
        created() {
            this.fetchPermitTypes();
        },
        computed: {
            dropdowns() {
                return window.dropdowns;
            },
        },
        methods: {
            onClickGeneratePermitNumber: function () {
                this.isLoadingPermitNumber = true;
                axios.post(this.appURL + '/api/reservepermits', {
                    permit_type: this.form.permit_type
                }).then((response) => {
                    if(response.status === 200) {
                        this.form.permit_number = response.data.permit.permit_number;
                    }
                    this.isLoadingPermitNumber = false;
                }).catch(error => {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = error.data.message;
                    this.isLoadingPermitNumber = false;
                });
            },
            async fetchPermitTypes() {
                this.isLoadingPermitTypes = true;
                await axios.get(this.appURL + '/api/permittypes')
                .then((response) => {
                    if(response.status === 200) {
                        this.permitTypes = response.data;
                    }
                    this.isLoadingPermitTypes = false;
                }).catch(error => {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = error.data.message;
                    this.isLoadingPermitTypes = false;
                });
            },

            onSubmitForm: function () {
                if (!this.$refs.form.validate()) {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = 'Looks like there are errors in the form!';
                }

                this.isLoadingFormSubmit = true;
                axios.post(this.appURL + '/api/nontypicalentry', {
                    'full_name' : this.form.full_name,
                    'uin': this.form.uin,
                    'phone' : this.form.phone_number,
                    'office':this.form.office,
                    'vehicle_plate_number' : this.form.vehicle.vehicle_licence_plate,
                    'vehicle_state' : this.form.vehicle.vehicle_state,
                    'vehicle_year' : this.form.vehicle.vehicle_year,
                    'vehicle_make' : this.form.vehicle.vehicle_make,
                    'vehicle_color' : this.form.vehicle.vehicle_color,
                    'permit_type' : this.form.permit_type,
                    'permit_number': this.form.permit_number,
                }).then((response) => {
                    if(response.status === 200) {
                        this.snack = true;
                        this.snackColor = 'success';
                        this.snackText = response.data.message;
                        this.isLoadingFormSubmit = false;
                    }
                    this.isLoadingFormSubmit = false;
                    this.resetForm();
                }).catch(error => {
                    this.snack = true;
                    this.snackColor = 'error';
                    this.snackText = error.response.data.message;
                    this.isLoadingFormSubmit = false;
                });
            },
            resetForm: function () {
                this.$refs.form.reset();
            }
        }
    }
</script>
